import StyleSheet from 'react-native-extended-stylesheet';

export const style = StyleSheet.create({
  divider: {
    marginVertical: '$space8',
  },
  options: {
    marginBottom: '$space6',
  },
  secondaryButton: {
    marginTop: '$space4',
  },
  title: {
    textAlign: 'center',
    marginVertical: '$space2',
  },
});
